import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadCatalogState, LoadCatalogStateModel } from './load-catalog.state';
import { SetInitialStateFacade } from '../../../../../../common/models';
import { LoadCatalogFetch, LoadCatalogInitialState } from './load-catalog.actions';
import { LoadPrimary, TransportCatalogSearchCriteria } from '../../models';

@Injectable({ providedIn: 'root' })
export class LoadCatalogFacade implements SetInitialStateFacade {
  listDto$: Observable<LoadCatalogStateModel> = this.store.select(LoadCatalogState.getState);
  items$: Observable<LoadPrimary[]> = this.store.select(LoadCatalogState.getItems);
  loaded$: Observable<boolean> = this.store.select(LoadCatalogState.getLoaded);

  constructor(private store: Store) {}

  load(searchCriteria: Partial<TransportCatalogSearchCriteria>): void {
    this.store.dispatch(new LoadCatalogFetch(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new LoadCatalogInitialState());
  }
}
